import React, { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import _ from "lodash";

import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase.js";
import AuthLayout from "../../components/AuthLayout.js";
import Message from "../../components/Message.js";
import Button from "../../components/Button.js";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [info, setInfo] = useState("");
  const [error, setError] = useState("");

  const location = useLocation();

  async function onSubmit(event) {
    event.preventDefault();
    setError("");
    setInfo("");

    try {
      await sendPasswordResetEmail(auth, email);
      setInfo("Er is een email naar je gestuurd met instructies!");
    } catch (err) {
      console.log(err);
      setError("Oeps! Controleer het emailadres even.");
    }
  }

  if (auth.currentUser && !auth.currentUser.isAnonymous) {
    return <Navigate replace to={_.get(location.state, "from", "/")} />;
  }

  return (
    <AuthLayout>
      <form id="forgot-password" onSubmit={onSubmit}>
        <h2 className="text-2xl font-heading font-bold mb-2">Wachtwoord vergeten?</h2>
        <p className="text-sm text-text-secondary mb-6">Vul je email in en we sturen je een link om je wachtwoord te resetten.</p>

        {!!error && (
          <div className="mb-4">
            <Message text={error} />
          </div>
        )}
        {!!info && (
          <div className="mb-4">
            <Message variant="success" text={info} />
          </div>
        )}

        <div className="space-y-4 mb-6">
          <div>
            <label className="label-base">Email</label>
            <input
              name="email"
              type="email"
              placeholder="Je emailadres"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-base"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <Button type="submit" label="Verstuur instructies" className="flex-1" />
          <Link
            to="/login"
            className="inline-flex items-center justify-center min-h-button px-4 py-2 text-base font-medium rounded-sm border border-border text-text-secondary hover:bg-bg-sunken transition-colors duration-fast"
          >
            Annuleren
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}

export default ForgetPassword;
